import {
  NumberStandardSettings,
  IncrementStandardSettings,
  SliderStandardSettings,
  CurrencyStandardSettings,
} from 'apps/studio/components/settings/fields/Number/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { ReferenceDataPanel } from 'apps/studio/components/settings/fields/Base/referenceData'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Base/advanced'
import { NumberAdvancedPanel, CurrencyAdvancedPanel } from 'apps/studio/components/settings/fields/Number/advanced'

export const NumberSettings = [
  FieldSettingsPanel(NumberStandardSettings),
  DesignSettingsPanel,
  ReferenceDataPanel,
  // ConditionsPanel,
  NumberAdvancedPanel,
]

export const IncrementSettings = [
  FieldSettingsPanel(IncrementStandardSettings),
  DesignSettingsPanel,
  ReferenceDataPanel,
  // ConditionsPanel,
  AdvancedPanel,
]

export const SliderSettings = [
  FieldSettingsPanel(SliderStandardSettings),
  DesignSettingsPanel,
  ReferenceDataPanel,
  // ConditionsPanel,
  AdvancedPanel,
]

export const CurrencySettings = [
  FieldSettingsPanel(CurrencyStandardSettings),
  DesignSettingsPanel,
  ReferenceDataPanel,
  // ConditionsPanel,
  CurrencyAdvancedPanel,
]
